import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'

import Text from './Text'

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Inter-Regular',
    color: colors.strongGray,
    fontSize: 12,
  },
  value: {
    fontSize: 14,
    fontFamily: 'Inter-Bold',
  },
})
// Create Document Component
export const Item = ({
  label, textColor, text, width, marginRight
}) => (
  <View style={{ width, marginRight }}>
    <Text style={styles.title}>{label}</Text>
    <Text style={{ ...styles.value, color: textColor }}>{text}</Text>
  </View>
)

Item.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  textColor: PropTypes.string,
  width: PropTypes.number,
  marginRight: PropTypes.number,
}

Item.defaultProps = {
  textColor: colors.titleStrongBlack,
  width: 112.75,
  marginRight: 32,
}
